import { EventEmitter, Injectable, Type } from "@angular/core";
import { IAccountingProcessAccountGroup } from "rl-common/services/accounting-processes/models/i-accounting-process-account-group";
import { IAccountingProcessAccountGroupRuleSet } from "rl-common/services/accounting-processes/models/i-accounting-process-account-group-rule-set";
import { ICreateAccountingProcessAccountGroupRule } from "rl-common/services/accounting-processes/models/i-create-accounting-process-account-group-rule";
import { ModalAdapter } from "rl-common/services/modal-adapter/modal-adapter";
import { IBuildAccountGroupRuleResult } from "./build-account-group-rule-modal.models";
export interface IBuildAccountGroupRuleModalComponent {
	accountGroup: IAccountingProcessAccountGroup;
	/** the account and the sequence number live on the Set now, so the rule modal only needs this */
	ruleSet: IAccountingProcessAccountGroupRuleSet;
	accountGroupRule: ICreateAccountingProcessAccountGroupRule;
	onClose: EventEmitter<IBuildAccountGroupRuleResult>;
}

@Injectable({ providedIn: "root" })
export class BuildAccountGroupRuleModalAdapter extends ModalAdapter<IBuildAccountGroupRuleModalComponent> {
	// eslint-disable-next-line @angular-eslint/prefer-inject -- modal component type is configuration supplied by the provider factory.
	constructor(type: Type<IBuildAccountGroupRuleModalComponent>) {
		super(type);
	}

}


